import tinycolor from 'tinycolor2';

// так как предзаполненный брендовый цвет WhatsApp при использовании tinycolor.isDark возвращает темный цвет, а нам нужен светлый
// поэтому был увеличен порог
export const customIsDark = (color: string) =>
  tinycolor(color).getBrightness() < 133 ? '#fff' : '#000';
